import { render } from "./Budgets.vue?vue&type=template&id=dbab1376"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/application/Budgets.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dbab1376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dbab1376', __exports__)) {
    api.reload('dbab1376', __exports__)
  }
  
  module.hot.accept("./Budgets.vue?vue&type=template&id=dbab1376", () => {
    api.rerender('dbab1376', render)
  })

}


export default __exports__